// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_15yor","Header":"_3BwB7","List":"_3tLtr","ListItem":"_1MoId"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Meals/MealsPaxSelectMobile/MealsPaxSelectMobile.scss
// module id = 578
// module chunks = 0